/**
 * Phase 7C — SafeLanguageWarnings (reusable, dependency-free).
 * Compact warning banner shown after create/patch responses when the backend
 * returns `safe_language_warnings`. Never blocks the flow.
 */
import React from 'react';
import { ShieldAlert } from 'lucide-react';
import theme from '../theme';

export default function SafeLanguageWarnings({ warnings }) {
  if (!Array.isArray(warnings) || warnings.length === 0) return null;

  const wrap = {
    padding: 12,
    background: '#FFFBEB',
    border: '1px solid #FDE68A',
    borderRadius: theme.radius.sm,
    color: '#78350F',
    marginTop: 10,
    marginBottom: 10,
  };

  return (
    <div data-testid="safe-language-warnings" style={wrap}>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center', fontWeight: 800, fontSize: 13 }}>
        <ShieldAlert size={14} /> Language Review Suggested
      </div>
      <div style={{ fontSize: 12, marginTop: 4 }}>
        Some language may create legal, financial, or customer-expectation risk.
        Review the suggested alternatives before publishing.
      </div>
      <ul style={{ margin: '8px 0 0 18px', padding: 0, fontSize: 12 }}>
        {warnings.map((w, i) => (
          <li key={`${w.field || ''}-${w.phrase || ''}-${i}`}
              data-testid={`safe-lang-row-${i}`}
              style={{ marginBottom: 4 }}>
            {w.field && <><b>{w.field}</b> · </>}
            <span style={{ background: '#FEF2F2', padding: '1px 6px', borderRadius: 4,
              color: '#991B1B', fontWeight: 700 }}>{w.phrase}</span>
            {w.severity && (
              <span style={{ marginLeft: 6, fontSize: 10, textTransform: 'uppercase',
                fontWeight: 800, color: (w.severity === 'high' ? '#991B1B' : '#78350F') }}>
                {w.severity}
              </span>
            )}
            {w.suggestion && <> — {w.suggestion}</>}
          </li>
        ))}
      </ul>
      <div style={{ marginTop: 8, fontSize: 11, color: theme.colors.text.muted }}>
        Kickback Contract does not guarantee payouts, financial outcomes, investment
        performance, legal compliance, or customer results.
      </div>
    </div>
  );
}
